import React from 'react'
import { connect } from 'react-redux'
import { Form, reduxForm, getFormValues } from 'redux-form'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'

import { relationOptions } from '../utils/constants'
import { showAlertMessage } from '../store/alert/actions'
import {
  getPickupAuthorizations,
  editPickupAuthorizationRSPA,
  approveTemporaryAuthorizationRSPA
} from '../store/pickup/actions'
import SearchPendingAuthorizationsForm from '../components/form/SearchPendingAuthorizationsForm'
import StyledSVG from '../components/shared/StyledSVG'
import triangleWarningSVG from '../assets/icons/triangle-warning-red.svg'
import Button from '../components/button/Button'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '64px 32px',
    fontFamily: 'Montserrat, Source Sans Pro',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    height: '100%',
    width: '96%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .title': {
      display: 'flex',
      alignItems: 'center',
      columnGap: 8,
      '& path': {
        stroke: '#386093'
      },
      '& h1': {
        margin: 0,
        fontSize: 32,
        fontWeight: 700,
        color: '#386093'
      }
    }
  },
  go_back_btn: {
    backgroundColor: '#F4A87C',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#F4A87C'
    },
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: '100%',
    height: 48,
    width: 144
  }
}))

const PickupPendingPage = ({
  handleSubmit,
  onSubmit,
  getPickupAuthorizations,
  editPickupAuthorizationRSPA,
  approveTemporaryAuthorizationRSPA,
  alert,
  authorizations,
  fieldValues
}) => {
  const classes = useStyles()
  const history = useHistory()
  const defaultParams = {
    'q[status_eq]': 0
  }
  const [searchParams, setSearchParams] = React.useState(null)

  React.useEffect(() => {
    getPickupAuthorizations({
      page: 1,
      params: {
        ...defaultParams
      }
    })
  }, [])

  React.useEffect(
    () => {
      const name = fieldValues?.name
      const relationship_type = fieldValues?.relationship_type
      const newParams = {
        ...(name?.length !== 0 ? { 'q[name_cont]': name } : {}),
        ...(relationship_type
          ? {
              'q[relationship_type_eq]': relationOptions.find(
                item => item.value === relationship_type
              )?.enum
            }
          : {})
      }
      setSearchParams(prev => ({ ...newParams }))
    },
    [fieldValues]
  )

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className='title'>
          <StyledSVG height={28} width={28} src={triangleWarningSVG} />
          <h1>Autorizações Pendentes</h1>
        </div>
        <Button
          type='button'
          onclick={() => history.goBack()}
          className={classes.go_back_btn}
        >
          Voltar
        </Button>
      </div>
      <p className='subtitle'>
        Revise, aprove ou rejeite novas solicitações de retirada com segurança.
      </p>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <SearchPendingAuthorizationsForm
          fieldValues={fieldValues}
          alert={alert}
          editPickupAuthorizationRSPA={editPickupAuthorizationRSPA}
          approveTemporaryAuthorizationRSPA={approveTemporaryAuthorizationRSPA}
          defaultParams={{ ...defaultParams, ...searchParams }}
          getPickupAuthorizations={getPickupAuthorizations}
          authorizations={authorizations}
        />
      </Form>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  return {
    fieldValues: getFormValues('searchPendingAuthorizationsForm')(state),
    authorizations: state.authorizations
  }
}

const mapDispatchToProps = dispatch => ({
  alert: (message, type) =>
    dispatch(
      showAlertMessage({
        message: message,
        severity: type
      })
    ),
  editPickupAuthorizationRSPA: data =>
    dispatch(editPickupAuthorizationRSPA.request(data)),
  approveTemporaryAuthorizationRSPA: data =>
    dispatch(approveTemporaryAuthorizationRSPA.request(data)),
  getPickupAuthorizations: data => dispatch(getPickupAuthorizations(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'searchPendingAuthorizationsForm',
    onSubmit: async (values, dispatch, props) => {}
  })(PickupPendingPage)
)
